import { useMemo } from 'react';

export const useAlertMarginTop = (
	withSmartMarginTop: boolean,
	topbarHeight: string,
	offset: number,
	defaultMarginTop: string,
) => {
	const marginTop = useMemo(() => {
		if (!withSmartMarginTop) return defaultMarginTop;

		const numericValue = parseFloat(topbarHeight);
		if (numericValue === 0) {
			return defaultMarginTop;
		}

		return `calc(${topbarHeight} + ${offset}px)`;
	}, [withSmartMarginTop, topbarHeight, offset, defaultMarginTop]);

	return marginTop;
};
